













































































































































































































































































































































































































import VueOptions from '@utils/VueOptions'
import PricingModel from '@services/PricingModel'
import RemoveFromCartTriggerModal from '@triggers/CheckoutWizard/RemoveFromCartTriggerModal'

settings =
  name: "EventFeedDetails"

  components: { RemoveFromCartTriggerModal }

  resources:
    event:
      resourceName: "event"
      slug: "events/:eventId"
    shopping_cart:
      resourceName: 'shopping_cart'
      slug: 'event_schedules/:selectedEventScheduleId/shopping_cart'
      fetch: false
    event_requests:
      resourceName: 'event_request'
      slug: 'event_requests'
      fetch: false

  vue:
    data: ->
      selectedSpaceName: null
      selectedSpaceType: null
      defaultSpaceType: 'product_sampling'
    computed:
      host: -> @ctxHost(@event) || {}
      schools: -> @ctxSchools(@event) || []
      socialMediaAccounts: -> @ctxSocialMediaAccounts(@event) || []

      selectedEventScheduleId: -> @getAppSession('selectedEventSchedule')?.id

      hasPhysicalInventory: ->
        x = false
        (x ||= !space.digital) for name, space of @event.spaces
        x and @event.in_person
      hasDigitalInventory: ->
        x = false
        (x ||= space.digital) for name, space of @event.spaces
        x
      hasLiveStreamSpace: ->
        x = false
        (x ||= space.type is 'native_integration') for name, space of @event.spaces
        x

      hasDrinkRestrictions: ->
        @event.allowed_distributors.length ||
        @event.restrictions.drink.sales_prohibited || @event.restrictions.drink.permit_required ||
        @event.restrictions.drink.insurance_required || @event.restrictions.drink.must_be_pre_packaged ||
        @event.restrictions.drink.must_be_prepared_off_site || @event.restrictions.drink.ingredients_must_be_displayed ||
        @event.restrictions.drink.alcohol_prohibited || @event.restrictions.drink.energy_drinks_prohibited ||
        @event.restrictions.drink.glass_prohibited || @event.restrictions.drink.sample_cups_only ||
        (@event.restrictions.drink.other_restrictions && @event.restrictions.drink.other_restrictions_info)
      hasFoodRestrictions: ->
        @event.restrictions.food.sales_prohibited || @event.restrictions.food.permit_required ||
        @event.restrictions.food.insurance_required || @event.restrictions.food.must_be_pre_packaged ||
        @event.restrictions.food.must_be_prepared_off_site || @event.restrictions.food.ingredients_must_be_displayed ||
        (@event.restrictions.food.other_restrictions && @event.restrictions.food.other_restrictions_info)
      isSingleDayEvent: -> dayjs(@event.local_start_day).isSame(dayjs(@event.local_end_day), 'day')
      instanceEvents: -> @ctxEventInstances(@event)
      hasOnlyOneInstance: -> (@instanceEvents.length - 1) is 0

      digitalSpaces: ->
        spaces = []
        for space_name, space of @event.spaces
          spaces.push space if space.digital
        spaces

      physicalSpaces: ->
        spaces = []
        # return spaces unless @event.physical_event
        for space_name, space of @event.spaces
          continue if 'product_sampling' is space.type and 0 is parseInt(space.min_quantity or 0)
          spaces.push space if not space.digital or not 'custom' is space.type
        spaces

      selectedSpaces: ->
        shoppingCart = @getAppSession('shoppingCart', [])
        cartItem = @lookupCartItemForEvent @event
        return cartItem?.spaces || []

      isWishlisted: -> !!@selectedSpaces.find((space) => space.name is @selectedSpaceName)
      isSingleSpaceAndSelected: -> @selectedSpaces.length is 1 and @isNotSelectedSpace
      isNotSelectedSpace: -> !!@selectedSpaces.find((space) => space.name is @selectedSpaceName)
      selectedSpace: -> @event.spaces[@selectedSpaceName]
      availableSpaceTypesForEvent: -> @event.space_types

      lineItems: -> @shopping_cart?.line_items || []

      enableActions: -> !(@$route.name is 'CheckoutEventDetails')

      publicTags: -> @event?.public_tags || []

      canRequestMoreInfo: ->
        return true if @event.can_request_for_more_info
        if @event.live_stream
          return true if @priceForSpace is 0 or @event.virtual.reach is 0
        return true if @event.physical_event and @event.reach is 0

      selectedSpacePriceIsZero: ->
        0 is @selectedSpace?.supplier_price_in_dollars

      quantityForCartItem: ->
        if 'product_sampling' is @selectedSpace?.type
          return @selectedSpace.min_quantity
        return 1

    methods:
      closeDetails: ->
        if @$route.name is 'CheckoutEventDetails'
          @$router.push({name: 'CheckoutPage' })
        else
          @$router.push({name: 'EventFeedListPage' })

      navigateToInstanceDetails: (instanceId) ->
        @$router.push({ name: 'EventFeedDetails', params: { eventId: instanceId } })
        @fetchAllResources()

      formatDateForEvent: (event) ->
        localStartDay = @$options.filters.formatDate(event.local_start_day, 'MM/DD/YYYY')
        localStartTime = @$options.filters.formatTime(event.local_start_time)

        localEndDay = @$options.filters.formatDate(event.local_end_day, 'MM/DD/YYYY')
        localEndTime = @$options.filters.formatTime(event.local_end_time)

        if @isSingleDayEvent
           "#{localStartDay} #{localStartTime} - #{localEndTime}"
        else
          "#{localStartDay} #{localStartTime} - #{localEndDay} #{localEndTime}"

      hiAddToCartTrigger: ->
        payload =
          event_id: @event.id,
          space_name: @selectedSpaceName,
          quantity: @quantityForCartItem
        @triggerResource 'shopping_cart', 'add_to_cart', payload
      onShoppingCartAddToCart: ->
        eventName = "#{@event.name.slice(0, 20)}"
        eventName = "#{eventName}..." if @event.name.length > 20
        @showMessage "#{eventName} (#{@selectedSpaceName}) has been added to your cart."
        @fetch('shopping_cart')
        @closeDetails()

      removeFromCartTrigger: ->
        cartItem = @lookupCartItemForEvent(@event)
        payload =
          line_item_id: cartItem.id
        @$refs.eventFeedRemoveFromCartTrigger.fire(payload)
      onShoppingCartRemoveFromCart: ->
        @$refs.eventFeedRemoveFromCartTrigger.close()
        @fetch('shopping_cart')
        @closeDetails()
        eventName = "#{@event.name.slice(0, 20)}"
        eventName = "#{eventName}..." if @event.name.length > 20
        @removeFromAppSessionList('shoppingCart', @event, 'id')
        @showMessage "#{eventName} (#{@selectedSpaceName}) has been removed from your cart."

      hiRemoveSpaceFromEvent: ->
        shoppingCart = [...@getAppSession('shoppingCart', [])]
        cartItem = @lookupCartItemForEvent @event
        space = @lookupSelectedSpaceForEvent @event
        spaces = @selectedSpaces.filter((s) -> s.type != space.type)
        cartItem.spaces = spaces
        @setAppSession('shoppingCart', shoppingCart)
        @closeDetails()

      spaceForSpaceType: (type) ->
        space = null
        (space ||= s) for n, s of @event.spaces when s.type is type
        space

      lookupSelectedSpaceForEvent: (event) -> event.spaces[@selectedSpaceName]
      eventForLineItem: (lineItem)-> @ctxEvent lineItem
      lookupCartItemForEvent: (event) ->
        @lineItems.find((lineItem) =>
          liEvent = @eventForLineItem(lineItem)
          isSameId = liEvent?.id is event.id
          isSameName = liEvent?.name is event.name
          isSameSpace = lineItem.space_name is @selectedSpaceName
          return lineItem if isSameId and isSameName and isSameSpace
        )

      initializeSpaceName: ->
        return unless @event?
        t = @getAppSession('selectedSpaceType', @defaultSpaceType)
        s = @spaceForSpaceType(t) || Object.keys(@event.spaces)[0]
        @selectedSpaceName = s?.name
        @selectedSpaceType = s?.type

      onLoadItemCompleted: (event) -> @initializeSpaceName()

      requestForMoreInfoTrigger: ->
        @triggerResource 'event_requests', 'request_for_more_info', { event_id: @event.id }
      onEventRequestsRequestForMoreInfo: ->
        @showFlash({ info: "Thanks for you interest. We'll let the organizer know that you want more info." })

    mounted: -> @initializeSpaceName()

export default VueOptions.vue settings
